export default "__VITE_ASSET__SLsuhGe$__"